<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

  </div>
</template>

<script>
import { settings } from '../configuration/settings'
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Bienvenido al sistema Inspecta versión ' + settings.version + '. Toma de datos en campo.'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
